import { render, staticRenderFns } from "./baseCourseWidget.vue?vue&type=template&id=47e6435e&scoped=true"
import script from "./baseCourseWidget.vue?vue&type=script&lang=js"
export * from "./baseCourseWidget.vue?vue&type=script&lang=js"
import style0 from "./baseCourseWidget.vue?vue&type=style&index=0&id=47e6435e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6435e",
  null
  
)

export default component.exports